import React, { useEffect, useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'

import { api_gateway } from '../../../conexoes/api'
import { setaDropdown } from '../../../utils/alternanciaIcones'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
export default function SelectOperadoraFaturas(props) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [lsOperadoras, setLsOperadoras] = useState([])
  const modal = useRef()

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  function handleOperadora(Operadora, cdOperadora) {
    props.setDsOperadora(Operadora)
    props.setCdOperadora(cdOperadora)
    handleCancelar()
  }

  function handleCancelar() {
    props.setRevelarSelectOperadoraFaturas(false)
  }

  useEffect(() => {
    async function renderOperadoras() {
      const { data } = await api_gateway.get(
        '/m1/consultar/operadora/operadora_faturas'
      )
      if (data.dados.length > 0) {
        let objetoOperadoras = data.dados.map((item, i) => {
          return (
            <li key={'menu-' + item.cd_dsp_operadora}>
              <div
                className="campo-select-opcao campo-select-opcao-3"
                onClick={() =>
                  handleOperadora(item.ds_dsp_operadora, item.cd_dsp_operadora)
                }
              >
                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                  {item.ds_dsp_operadora}
                </span>
              </div>
              {data.dados[i + 1] != undefined && (
                <div className="campo-select-divisor-cor-1 campo-select-divisor" />
              )}
            </li>
          )
        })
        setLsOperadoras(objetoOperadoras)
      } else {
        let objetoOperadoras = () => {
          return (
            <li>
              <div disabled className="campo-select-opcao campo-select-opcao-3">
                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                  Nenhuma informação encontrada
                </span>
              </div>
            </li>
          )
        }
        setLsOperadoras(objetoOperadoras)
      }
    }
    renderOperadoras()
    setSpinAtivo(false)
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Form ref={modal}>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <Button
        name="cdTipoPessoa"
        className="campo-texto-cor-3 campo-select"
        onClick={() => props.setRevelarSelectOperadoraFaturas(false)}
      >
        <div className="fonte-cor-1 label-campo">{props.dsOperadora}</div>
        <img
          className="campo-select-icone-ativado"
          src={setaDropdown()}
          alt="drop"
        />
      </Button>
      <div className="modal-select-operadora">
        <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
        <div className="campo-texto-cor-3 campo-select-corpo">
          <ul className="campo-select-lista">{lsOperadoras}</ul>
        </div>
      </div>
    </Form>
  )
}
